/*
 *  Базовое представление для поповеров
 *  @author Pavel Tretyakov <tretyakovpavel.ru@gmail.com>
 *  @copy 2015
 *
 *  Параметры модели:
 *
 *  popover-id      : css идентификатор, обязательно переназначать
 *  show            : Системный параметр для отобржанеие поповера
 *  title           : Заголовок окна
 *  placement       : Расположение поповера (left|right|top|bottom)
 *  arrow_position  : Расположение стрелки (left|center|right|top|bottom)
 *  show_body       : Отображать ли тело
 *  show_header     : Отображать ли голову
 *  show_footer     : Отображать ли ноги
 *  height          : Высота поповера
 *
 */


define(function(require){
 	'use strict';


     var _ = require('underscore'); 
 	var Marionette = require('marionette');

 	var template   = require('text!popovers/_base/templates/popover.tpl').default;
    var BodyTPL    = require('text!popovers/_base/templates/body.tpl').default;
    var HeaderTPL  = require('text!popovers/_base/templates/header.tpl').default;
    var FooterTPL  = require('text!popovers/_base/templates/footer.tpl').default;

    var BodyView    = Marionette.ItemView.extend({ template : BodyTPL });
    var HeaderView  = Marionette.ItemView.extend({ template : HeaderTPL });
    var FooterView  = Marionette.ItemView.extend({ template : FooterTPL });

    var _           = require('underscore');

    var modal       = require('behaviors/modal');

    require('webui-popover');

    var Model = Backbone.Model.extend({
        defaults : {
            popover_id      : '',
            curElement      : null,  // элемент по которому кликнули
            show            : true ,
            title           : '' ,
            show_body       : true ,
            show_footer     : true ,
            show_header     : true ,
            opened          : false,
            zIndex          : 999999999,
            sysScroll       : false, // скрывать при системном скролле (на боди)
            sysScrollDelay  : false  // то же самое что sysScroll но прослушка начинается после показа поповера
        }
    });

 	return Marionette.LayoutView.extend({
        template    : template,
        className   : 'popover-main',
        debug       : false,

        ui : {
            'area'  : '.js-popover-area'
        },

        parentEvents: {
            'click a'   : 'hide',
            'click .js-popover-close': 'hide'
        },
        newEvents: {}, // события детей
        events : function() {
            return _.extend({}, this.parentEvents, this.newEvents);
        },

        behaviors: {
            'modal': { behaviorClass : modal }
        },

 		regions: {
 			regionHeader : ".popover-header",
 			regionBody   : ".popover-body",
 			regionFooter : ".popover-footer"
 		},

 		initialize : function(options){
            var self = this;

 			this.model = new Model(options);
 			this.on('render', this.afterRender);

            // Скрываем поповер, если произошло изменение размера окна
            this.setResizeListener();

            this.listenTo(app.Vents, 'datatable:scroll', this.hide);
            this.listenTo(app.Vents, 'popover:close', this.hide);
            this.listenTo(app.Vents, 'app:changeProject', this.closeAll);
            this.listenTo(app.Router, 'route', this.closeAll);

            this.autoHideHandler = this.autoHideHandler || this.checkAutoHide.bind(this);
            $(document).on('mousedown' , this.autoHideHandler);
 		},

        checkAutoHide: function(e) {
            if (this.model.get('popoverData').preventClose || $(e.target).closest('.webui-popover, .datepicker, .clockpicker-popover, .k-datetimepicker, .k-animation-container, .mce-container, #mce-modal-block, .js-funnel-step-date-area, .k-calendar-container, .k-list-container, .intro-tooltip__next, .js-intro-overlay, .tooltip-inner').length) {
                return;
            }

            if ($(e.target).closest(this.model.get('curElement')).length){
                this.model.get('curElement').data('test');
                return;
            }

            if(!this.isDestroyed) {
                this.hide();
            }
        },

        closeAll: function() {
            $('.webui-popover').remove();
            this.destroy();
            return this;
        },

        /**
         * @return {void} : Вызвает методы для отображения поповера
         */
 		afterRender : function(){
            var maxHeight = this.model.get('maxHeight');
            var minHeight = this.model.get('minHeight');

 			this.showHeader();
 			this.showBody();
 			this.showFooter();

            this.$('.popover-body').css('height',  this.model.get('height'));

            if (maxHeight) {
                this.$('.popover-body').css('max-height', maxHeight);
            }

            if (minHeight) {
                this.$('.popover-body').css('min-height', minHeight);
            }

            setTimeout(function () {
                var isFirefoxOnMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0 && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
                if (isFirefoxOnMac) {
                    app.States.isFirefoxOnMac = true;
                    // $('.webui-popover-content').prop('style', 'overflow-y: scroll !important');
                } else {
                    app.States.isFirefoxOnMac = false;
                }

                //this.checkHeight();
            }.bind(this), 1000);
        },

        checkHeight: function () {
            var windowHeight = $(window).height(),
                $webuiPopover = $('.webui-popover'),
                elOffsetTop = this.model.get('curElement').offset().top,
                newHeight = (windowHeight - elOffsetTop) - 60;

            // If Popover height greater than available space
            if (windowHeight - ($webuiPopover.height() + elOffsetTop) > 40) return;

            $webuiPopover.css({
                'height': newHeight + 'px',
                'top': (elOffsetTop + 32) + 'px'
            });
            $('.webui-popover-content').css({
                'height': (newHeight - 10) + 'px',
                'overflow-y': 'auto'
            });
        },

        show: function() {
            var that           = this,
                $curElement    = this.model.get('curElement'),
                curElOffsetTop = $curElement.offset().top,
                content        = this.render().$el,
                $window        = $(window),
                $webuiPopover  = $('.webui-popover'),
                modelAttrs     = this.model.toJSON();

            // Проверка, чтобы поповер не терялся внизу
            if($window.height() - (curElOffsetTop - $window.scrollTop()) < 100){
                this.model.set('placement' , 'top');
            }

            var options = _.defaults(modelAttrs, {
                content     : content,
                trigger     : 'manual',
                dismissible : true
            });

            $curElement.webuiPopover(options);
            $curElement.webuiPopover('show');

            // Refreshing webui element after plugin applied styles
            $webuiPopover  = $('.webui-popover');

            var attrs  = $webuiPopover.attr('style'),
                zIndex = this.model.get('z-index') || this.model.get('zIndex');

            attrs += '; z-index: ' + zIndex + ' !important';
            if (modelAttrs.maxHeight) {
                $webuiPopover.find('.webui-popover-content').attr('style', 'max-height:' + modelAttrs.maxHeight + ';overflow-y: auto !important;');
            }

            $webuiPopover.attr('style', attrs);

            if($curElement.closest('.scrollbar-macosx').length > 0){
                $curElement.closest('.scrollbar-macosx').scroll(function(){
                    that.hide();
                });
            }

            $('[data-toggle="tooltip"]').tooltip({animation:false});

            // Если высота динамически меняется и надо распологать сверху
            if (this.model.get('position') === 'dynamicHeight') {
                var bottomPosition = $window.height() - curElOffsetTop + 50,
                    newPositionStyle = $webuiPopover.attr('style') + ';top: auto !important;bottom:' + bottomPosition + 'px  !important';

                $webuiPopover.find('.arrow').show();
                $webuiPopover.attr('style', newPositionStyle);
            }

            if(this.model.get('sysScroll') === true){
                this.setWindowScrollListener();
            }

            if(this.model.get('sysScrollDelay') === true){
                setTimeout(this.setWindowScrollListener.bind(this), 2000);
            }
        },

        setWindowScrollListener: function() {
            this.scrollHandler = this.scrollHandler || this.hide.bind(this);
            if(!app.isMobile) {
                $(window).on('scroll', this.scrollHandler);
            }
        },

        setResizeListener: function() {
            this.resizeHandler = this.resizeHandler || this.hide.bind(this);
            if(!app.isMobile || window.innerWidth > 700) {
                $(window).on('resize', this.resizeHandler.bind(this));
            }
        },

        hide: function(e){
            var curElement  = this.model.get('curElement');
            if(this.$('select.select2').data('select2')) {
                this.$('select.select2').select2('destroy');
            }
            curElement.attr('data-openedpop' , false);
            curElement.webuiPopover('destroy');
            if (app.Temp.popoverDataSaved) {
                app.message.success('Сохранено', undefined, undefined, { id: 'saved' });
                app.Temp.popoverDataSaved = false;
            }
            app.Vents.trigger('popover:closed');
            app.Utils.Listener.ignoreScroll({
                target   : $(window)
            });
            this.destroy();
        },

        /**
         * @return {void} : Отображает регион с головой поповера
         */
        showHeader : function(){
        	if(this.model.get('show_header')){
                this.regionHeader.show(new HeaderView({ model: this.model }));
            }
        } ,

        /**
         * @return {void} : Отображает регион с телом поповреа
         */
        showBody : function(){
            this.regionBody.show(new BodyView({ className: this.className }));
        } ,

        /**
         * @return {void} : Отображает регион с ногами поповреа
         */
        showFooter : function(){
        	if(this.model.get('show_footer')){
                this.regionFooter.show(new FooterView({ model: this.model }));
            }
        },

        onBeforeDestroy: function() {
            this.$('[data-toggle="tooltip"]').tooltip('destroy');
        },

        onDestroy : function (){
            $(document).off('mousedown', this.autoHideHandler);
            $(window).off('scroll', this.scrollHandler);
            $(window).off('resize', this.resizeHandler);
        }

 	});

 });
